import React from "react";
import "./experience.css";
import { AiFillHtml5 } from "react-icons/ai";
import {
  DiCss3,
  DiJavascript,
  DiMysql,
  DiReact,
  DiRedis,
} from "react-icons/di";
import { BsBootstrapFill } from "react-icons/bs";
import { SiMui, SiRedux, SiJquery, SiMongodb } from "react-icons/si";
import { FaNodeJs } from "react-icons/fa";
import {
  SiExpress,
  SiJavascript,
  SiTypescript,
  SiPython,
  SiDart,
  SiTailwindcss,
  SiFlutter,
} from "react-icons/si";
import { TbBrandCpp, TbBrandNextjs } from "react-icons/tb";
import { GetxIcon, RiverpodIcon } from "../../assets";

const Experience = () => {
  return (
    <section id="experience">
      <h5>What Skills I Have</h5>
      <h2>My Experience</h2>

      <div className="container experience__container">
        <div className="experience__languages">
          <h3>Programming Languages</h3>
          <div className="experience__content">
            <article className="experience__details">
              <TbBrandCpp className="experience__details-icon" />
              <div>
                <h4>C/C++</h4>
              </div>
            </article>
            <article className="experience__details">
              <SiJavascript className="experience__details-icon" />
              <div>
                <h4>Javascript</h4>
              </div>
            </article>
            <article className="experience__details">
              <SiTypescript className="experience__details-icon" />
              <div>
                <h4>Typescript</h4>
              </div>
            </article>
            <article className="experience__details">
              <SiPython className="experience__details-icon" />
              <div>
                <h4>Python</h4>
              </div>
            </article>
            <article className="experience__details">
              <SiDart className="experience__details-icon" />
              <div>
                <h4>Dart</h4>
              </div>
            </article>
          </div>
        </div>

        <div className="experience__frontend">
          <h3>Frontend Development</h3>
          <div className="experience__content">
            <article className="experience__details">
              <AiFillHtml5 className="experience__details-icon" />
              <div>
                <h4>HTML5</h4>
              </div>
            </article>
            <article className="experience__details">
              <DiCss3 className="experience__details-icon" />
              <div>
                <h4>CSS3</h4>
              </div>
            </article>
            <article className="experience__details">
              <DiJavascript className="experience__details-icon" />
              <div>
                <h4>Javascript</h4>
              </div>
            </article>
            <article className="experience__details">
              <DiReact className="experience__details-icon" />
              <div>
                <h4>ReactJs</h4>
              </div>
            </article>
            <article className="experience__details">
              <TbBrandNextjs className="experience__details-icon" />
              <div>
                <h4>NextJs</h4>
              </div>
            </article>
            <article className="experience__details">
              <SiRedux className="experience__details-icon" />
              <div>
                <h4>Redux</h4>
              </div>
            </article>
            <article className="experience__details">
              <BsBootstrapFill className="experience__details-icon" />
              <div>
                <h4>Bootstrap</h4>
              </div>
            </article>
            <article className="experience__details">
              <SiMui className="experience__details-icon" />
              <div>
                <h4>Material UI</h4>
              </div>
            </article>
            <article className="experience__details">
              <SiTailwindcss className="experience__details-icon" />
              <div>
                <h4>Tailwind CSS</h4>
              </div>
            </article>
            <article className="experience__details">
              <SiJquery className="experience__details-icon" />
              <div>
                <h4>Jquery</h4>
              </div>
            </article>
          </div>
        </div>

        <div className="experience__backend">
          <h3>Backend Development</h3>
          <div className="experience__content">
            <article className="experience__details">
              <FaNodeJs className="experience__details-icon" />
              <div>
                <h4>NodeJs</h4>
              </div>
            </article>
            <article className="experience__details">
              <SiExpress className="experience__details-icon" />
              <div>
                <h4>ExpressJs</h4>
              </div>
            </article>
            <article className="experience__details">
              <DiRedis className="experience__details-icon" />
              <div>
                <h4>Redis</h4>
              </div>
            </article>
            <article className="experience__details">
              <SiMongodb className="experience__details-icon" />
              <div>
                <h4>Mongodb</h4>
              </div>
            </article>
            <article className="experience__details">
              <DiMysql className="experience__details-icon" />
              <div>
                <h4>Mysql</h4>
              </div>
            </article>
          </div>
        </div>

        <div className="experience__app">
          <h3>Application Development</h3>
          <div className="experience__content">
            <article className="experience__details">
              <SiFlutter className="experience__details-icon" />
              <div>
                <h4>Flutter</h4>
              </div>
            </article>
            <article className="experience__details">
              <img
                src={RiverpodIcon}
                alt="riverpod-icon"
                className="experience__details-icon"
              />
              <div>
                <h4>RiverPod</h4>
              </div>
            </article>
            <article className="experience__details">
              <img
                src={GetxIcon}
                alt="getx-icon"
                className="experience__details-icon"
              />
              <div>
                <h4>GetX</h4>
              </div>
            </article>
            <article className="experience__details">
              <DiReact className="experience__details-icon" />
              <div>
                <h4>React Native</h4>
              </div>
            </article>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;
